module.exports = __webpack_public_path__ + "static/media/logo-itiuba.6fc8bd62.png";